import { render, staticRenderFns } from "./TermPage.vue?vue&type=template&id=b4154fcc"
import script from "./TermPage.vue?vue&type=script&lang=js"
export * from "./TermPage.vue?vue&type=script&lang=js"
import style0 from "./TermPage.vue?vue&type=style&index=0&id=b4154fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports